exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".filter-input{width:400px}.customer-table .col-process{width:250px}.customer-table .col-actions{width:230px}", ""]);

